import React, { useState } from 'react';
import './Achievements.css';

function Achievements({ currentUser }) {
  const [filter, setFilter] = useState('all');

  const achievements = [
    { id: 1, name: 'First Entry', description: 'Enter your first giveaway', icon: '🎯', unlocked: true, progress: 100, rarity: 'common' },
    { id: 2, name: 'Entry Master', description: 'Enter 10 giveaways', icon: '🎁', unlocked: true, progress: 100, rarity: 'common' },
    { id: 3, name: 'Entry Legend', description: 'Enter 50 giveaways', icon: '👑', unlocked: false, progress: 45, rarity: 'rare' },
    { id: 4, name: 'Winner', description: 'Win your first giveaway', icon: '🏆', unlocked: false, progress: 0, rarity: 'epic' },
    { id: 5, name: 'Lucky Streak', description: 'Win 3 giveaways', icon: '🍀', unlocked: false, progress: 0, rarity: 'legendary' },
    { id: 6, name: 'Social Butterfly', description: 'Send 100 chat messages', icon: '💬', unlocked: true, progress: 100, rarity: 'common' },
    { id: 7, name: 'Message Master', description: 'Send 500 chat messages', icon: '📨', unlocked: false, progress: 65, rarity: 'rare' },
    { id: 8, name: 'Early Bird', description: 'Enter a giveaway within 1 hour of creation', icon: '🐦', unlocked: true, progress: 100, rarity: 'rare' },
    { id: 9, name: 'Dedicated', description: 'Log in 30 days in a row', icon: '🔥', unlocked: false, progress: 12, rarity: 'epic' },
    { id: 10, name: 'Community Helper', description: 'Help 10 users', icon: '🤝', unlocked: false, progress: 0, rarity: 'rare' },
    { id: 11, name: 'Boost User', description: 'Use an entry boost', icon: '⚡', unlocked: true, progress: 100, rarity: 'common' },
    { id: 12, name: 'Profile Complete', description: 'Complete your profile', icon: '✅', unlocked: true, progress: 100, rarity: 'common' },
  ];

  const filteredAchievements = filter === 'all' 
    ? achievements 
    : filter === 'unlocked' 
    ? achievements.filter(a => a.unlocked)
    : achievements.filter(a => !a.unlocked);

  const unlockedCount = achievements.filter(a => a.unlocked).length;
  const totalCount = achievements.length;
  const completionRate = ((unlockedCount / totalCount) * 100).toFixed(0);

  return (
    <div className="achievements-page">
      <div className="achievements-container">
        <div className="achievements-header">
          <h1>🏅 Achievements</h1>
          <div className="achievement-stats">
            <div className="stat-item">
              <span className="stat-number">{unlockedCount}</span>
              <span className="stat-label">Unlocked</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{totalCount}</span>
              <span className="stat-label">Total</span>
            </div>
            <div className="stat-item">
              <span className="stat-number">{completionRate}%</span>
              <span className="stat-label">Complete</span>
            </div>
          </div>
        </div>

        <div className="achievements-controls">
          <button
            className={filter === 'all' ? 'active' : ''}
            onClick={() => setFilter('all')}
          >
            All
          </button>
          <button
            className={filter === 'unlocked' ? 'active' : ''}
            onClick={() => setFilter('unlocked')}
          >
            Unlocked
          </button>
          <button
            className={filter === 'locked' ? 'active' : ''}
            onClick={() => setFilter('locked')}
          >
            Locked
          </button>
        </div>

        <div className="achievements-grid">
          {filteredAchievements.map(achievement => (
            <div
              key={achievement.id}
              className={`achievement-card ${achievement.unlocked ? 'unlocked' : 'locked'} rarity-${achievement.rarity}`}
            >
              <div className="achievement-icon">{achievement.icon}</div>
              <div className="achievement-info">
                <h3>{achievement.name}</h3>
                <p>{achievement.description}</p>
                {!achievement.unlocked && (
                  <div className="achievement-progress">
                    <div className="progress-bar">
                      <div
                        className="progress-fill"
                        style={{ width: `${achievement.progress}%` }}
                      ></div>
                    </div>
                    <span className="progress-text">{achievement.progress}%</span>
                  </div>
                )}
                {achievement.unlocked && (
                  <span className="unlocked-badge">✓ Unlocked</span>
                )}
              </div>
              <div className={`rarity-badge rarity-${achievement.rarity}`}>
                {achievement.rarity}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Achievements;

